export const TOOLTIP_DELAY = 400;
